<template>
    <div class="search-results-container">
      <button
        class="btn clear-search-results"
        @click="setSearchResults({ errorMessage:'', data:[] }), clearSearchResults()"
      >
      {{$t('tuka.search.text_results_clear')}}
      </button>

      <h2 class="results-header">{{$t('tuka.search.text_results_header')}} <span class="results-header-word">{{getTextSearchStaticValue}}</span></h2>
      <div class="results-count-total">{{$t('tuka.search.text_results_count')}} {{searchResults.data.length}}</div>
      <div class="results-error">{{searchResults.errorMessage}}</div>

      <search-result
        v-if="searchResults && searchResults.data.length" 
        v-for="(item, index) of searchResults.data"
        :key="'result-' + index"
        :item="item"
      />

    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { createUrlString } from "../store/helpers";

import SearchInfo from "./SearchInfo.vue";
import SearchResult from "./SearchResult.vue";

export default {
  name: "SearchResults",
  components: {  
    SearchInfo,
    SearchResult
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["searchResults", "themeWords", "getSettings", "getTextSearchStaticValue", "currentItemLocationData"]),
  },
  methods: {
    ...mapActions(["setSearchResults", "setSettings", "setScrollingReserved", "setTextSearchValue"]),
    clearSearchResults() {

      // Set content into normal width, show full-size sidebar
      let tempSettings = this.getSettings;
      tempSettings.showContentWindowInFullWidth = false;
      this.setSettings(tempSettings);

      // Remove content from search box (note: does not empty textSearchStaticValue)
      this.setTextSearchValue("");

      // Generate componentId array, e.g. ["0","1","3"] --> ["1","3"]
      // Note: prevent root item ["0"] to be inserted at tempLocation 
      let tempLocation = [];
      for (let i = 1; i < this.currentItemLocationData.length; i++) {
        tempLocation.push(this.currentItemLocationData[i]);
      }

      // Prevent root item ["0"] to be inserted to url
      if (tempLocation && tempLocation[0] == "0") {
        tempLocation = [];
      }

      let pushParams = {
        componentPage: this.$router.currentRoute.params.componentPage,
        componentId: tempLocation,
      }

      this.$router.push({
        name: 'componentpage',
        params: pushParams,
        query: {},
        hash: ""
      }).catch(err => { console.log(err); console.log("Reroute to same location, avoiding")})

      // Focus main content
      this.$nextTick(() => {
        // Focus main content area
        document.getElementById('tuka-content-container').focus({
          preventScroll: true
        });
      });
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
